export default __webpack_public_path__ + "static/media/plane.6d358f01.svg";